import React from 'react'
import { ServiceCardData } from './Components/ServiceCardData'
import { BankServicesData } from './Components/BankServicesData'
import { Link } from 'react-router-dom'

const Services = () => {
  return (
    <>

      {/* // x---------------------------------x Services Cards Section x---------------------------------x  */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 xl:grid-cols-4 gap-4">
        {ServiceCardData.map((data, index) => {
          return (
            <div key={index}>
              <div className="card border-none bg-transparent h-full">
                <div className="card-body rounded-2xl sm:p-4 p-3 h-full">
                  <div className="flex items-center gap-4">
                    <div className={`card-img w-16 h-16 rounded-full flex items-center justify-center ${data.icon_bg}`}>
                      {data.icon}
                    </div>
                    <div className="card-text">
                      <p className="text-dark opacity-50 text-base m-0">{data.Heading}
                      </p>
                      <p className="text-dark font-bold text-lg m-0">{data.Description}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
        })}
      </div>

      {/* // x---------------------------------x Bank Services List // x---------------------------------x  */}
      <div className="my-2 grid grid-cols-1 gap-3">
        <div className="col-span-12">
          <div className="card bg-transparent h-full">
            <div className="card-header flex justify-between items-center">
              <h3 className="text-dark p-3 sm:text-2xl font-semibold">Bank Services List</h3>
              <Link to="/" className="text-gray-900 text-end text-sm font-semibold block sm:hidden">
                See all
              </Link>
            </div>
            <div className="card-body p-2 rounded-xl">
              <ul className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 gap-3 list-none mb-0" id="MyClients">
                {BankServicesData.map((data, index) => (
                  <li key={index}>
                    <div className="bg-body text-dark p-5 rounded-xl text-gray-800 h-full">
                      <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-5 items-center gap-y-4">
                        <div className="md:flex  items-center">
                          <div className={`card-img w-14 h-14 rounded-xl mr-4 flex items-center justify-center ${data.icon_bg}`}>
                            {data.icon}
                          </div>
                          <div>
                            <p className="md:mb-1 text-lg font-semibold">{data.ServiceType}</p>
                            <span className="text-gray-500 text-sm">{data.ServiceTypeText}</span>
                          </div>
                        </div>
                        <div>
                          <p className="md:mb-1 text-lg font-semibold">{data.ServiceSuggestion}</p>
                          <span className="text-gray-500 text-sm">{data.ServiceSuggestionText}</span>
                        </div>
                        <div>
                          <p className="md:mb-1 text-lg font-semibold">{data.Type}</p>
                          <span className="text-gray-500 text-sm">{data.Type}</span>
                        </div>
                        <div>
                          <p className="md:mb-1 text-lg font-semibold">{data.Control}</p>
                          <span className="text-gray-500 text-sm">{data.ControlText}</span>
                        </div>
                        <div className='sm:justify-self-cente sm:col-span-2 lg:col-span-1 '>
                          <Link
                            to="/business-loan"
                            className="border rounded-full px-4 py-2 border-blue-500 text-blue-500 hover:bg-blue-500 hover:text-white transition-colors"
                          >
                            View More
                          </Link>
                        </div>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </div >
          </div >
        </div >
      </div>
    </>
  )
}

export default Services